import { useState } from "react";
import { queryClient } from "@/queryClient";
import useAuth from "@/modules/common/hooks/auth.hook";
import { toast } from "react-toastify";
import { deleteTrackComment } from "../../api";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

const useDeleteComments = ({ trackUId }: { trackUId: string }) => {
  const [dialogOpenConfirm, setDialogOpenConfirm] = useState(false);
  const [dialogOpenFeedback, setDialogOpenFeedback] = useState(false);
  const [onMouseHover, setOnMouseHover] = useState(false);
  const { user } = useAuth();

  const deleteCommentMutation = useDomainMutation(
    async (commentId: string | undefined) => {
      if (!commentId) return Promise.reject("commentId is undefined");
      return await deleteTrackComment(trackUId, commentId);
    },
    {
      onSuccess: () => {
        toast.success("Comment deleted successfully", {
          position: "bottom-left",
        });

        queryClient.invalidateQueries({ queryKey: ["track"] });
      },
      onError: () => {
        setDialogOpenFeedback(true);
      },
    }
  );

  const handleDeleteComments = (commentId: string | number | undefined) => {
    deleteCommentMutation.mutate(commentId?.toString());
    setDialogOpenConfirm(false);
  };

  return {
    handleDeleteComments,
    setDialogOpenFeedback,
    setDialogOpenConfirm,
    setOnMouseHover,
    dialogOpenConfirm,
    dialogOpenFeedback,
    onMouseHover,
    errorDeleting: deleteCommentMutation.isError,
    loadDeleting: deleteCommentMutation.isPending,
    userUId: user?.["cognito:username"],
  };
};

export default useDeleteComments;
